module.exports = __webpack_public_path__ + "static/media/imagem10.a118097e.jpeg";